var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"left-title"},[_c('h1',[_vm._v(" Ayudamos a DISTRIBUIDORAS a GANAR TIEMPO en la gestion de su negocio ")]),_c('h3',[_vm._v(" Nos encargamos de implementar y poner en marcha un sistema de gestion personalizado. Con desarrollos a medida para que puedas realmente delegar la gestion de todos tus procesos en un unico lugar. ")])])
}]

export { render, staticRenderFns }